var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-980 -565) translate(631 371) translate(350 194) translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.8,
    cy: 16.8,
    r: 16.8,
    fillRule: "nonzero",
    stroke: "#E5E7DF",
    strokeWidth: 0.843
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8CAEB4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.352 19.969c-.584 0-1.153-.218-1.588-.615C.278 18.911 0 18.28 0 17.624v-3.15c0-1.195.892-2.197 2.075-2.33.696-.079 1.387-.222 2.055-.426.835-.256 1.735-.034 2.348.579l1.276 1.276c2.444-1.337 4.482-3.375 5.819-5.819l-1.276-1.276c-.613-.613-.835-1.513-.58-2.348.205-.668.348-1.36.427-2.055C12.277.892 13.279 0 14.474 0h3.149c.657 0 1.288.278 1.731.764.445.488.666 1.145.605 1.803-.208 2.26-.807 4.442-1.78 6.485-.946 1.987-2.218 3.786-3.78 5.347-1.561 1.562-3.36 2.834-5.347 3.78-2.043.973-4.225 1.572-6.485 1.78-.072.007-.143.01-.215.01zm2.472-6.795c-.079 0-.16.011-.238.035-.76.233-1.545.396-2.337.485-.393.044-.689.38-.689.78v3.15c0 .222.09.428.256.578.166.152.382.224.608.203 8.48-.78 15.2-7.501 15.981-15.98.021-.227-.051-.443-.203-.61-.15-.164-.356-.255-.579-.255h-3.15c-.4 0-.735.296-.78.69-.088.79-.251 1.577-.483 2.336-.087.283-.014.585.19.79l2.078 2.077-.25.502c-1.558 3.131-4.141 5.714-7.273 7.272l-.502.25L5.375 13.4c-.147-.147-.345-.226-.551-.226z",
    transform: "matrix(-1 0 0 1 27 7)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/contact-phone.4d239f260a3b1e13e1a41632ceb361f9.svg";
export { ForwardRef as ReactComponent };